module.exports = __webpack_public_path__ + "static/media/anc2kz.fff5ab34.pdf";